/* ============================================================
   TRIKA FAQ — JavaScript
   assets/trika-faq.js
   
   ============================================================ */

(function () {
  'use strict';

  function initFaqAccordions(root) {
    root = root || document;
    var buttons = root.querySelectorAll('.faq-item__question');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item   = btn.closest('.faq-item');
        var answer = item.querySelector('.faq-item__answer');
        var isOpen = item.classList.contains('is-open');

        // Close all siblings in same list
        var list = item.closest('.faq-list');
        if (list) {
          list.querySelectorAll('.faq-item.is-open').forEach(function (openItem) {
            openItem.classList.remove('is-open');
            openItem.querySelector('.faq-item__question').setAttribute('aria-expanded', 'false');
            openItem.querySelector('.faq-item__answer').style.maxHeight = '0';
          });
        }

        // Toggle clicked item
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  // Init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFaqAccordions(); });
  } else {
    initFaqAccordions();
  }

  // Re-init after Shopify section loads (Theme Editor)
  document.addEventListener('shopify:section:load', function (e) {
    initFaqAccordions(e.target);
  });

})();
